var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12.001 3.99c.05 0 6.886 0 8.597.477.947.263 1.692 1.036 1.945 2.02h-.002c.46 1.782.46 5.502.46 5.502 0 .033-.002 3.727-.46 5.501-.253.984-.998 1.757-1.945 2.02-1.709.477-8.546.48-8.595.48 0 0-6.88-.002-8.595-.48-.947-.263-1.691-1.036-1.945-2.02-.458-1.774-.46-5.468-.46-5.5 0 0 0-3.721.46-5.503.254-.984.998-1.757 1.945-2.02C5.12 3.989 12 3.989 12 3.989m-2.2 11.429 5.717-3.428L9.8 8.563z"
})));
export default SvgYoutube;